import React, {useEffect, useState} from "react";
import {Button} from "../../../../../Components/Inputs";
import {GridCell, GridTable} from "../../../../../Components/Grid";
import {emptyLoanLibraryInventoryItemModel} from "./loanLibraryInventoryItemFactory";
import {LoanLibraryInventoryRow} from "./LoanLibraryInventoryRow";
import * as PolicyEvents from "../../../../../Components/Authorize/policyEventsConstants";
import {allow} from "../../../../../Components/Authorize";
import {LoanLibraryInventoryEditRow} from "./LoanLibraryInventoryEditRow";
import {getLoanLibraryInventoryItemId} from "./loanLibraryInventoryUtility";

export const LoanLibraryInventoryView = ({
                                             loanLibraryInventoryItems = [],
                                             onInventoryChange,
                                             onInventoryEditingChanged,                                             
                                             loanLibraryCatalogItemId,
                                             productName,
                                         }: {
    loanLibraryInventoryItems?: Record<string, unknown>[];
    onInventoryChange: (items: Record<string, unknown>[]) => void;
    onInventoryEditingChanged?: (isEditing: boolean) => void;
    loanLibraryCatalogItemId: string;
    productName?: string;
}) => {

    const [editingIndex, setEditingIndex] = useState(-1);
    const canManageCatalog = allow(PolicyEvents.MANAGE_LOAN_LIBRARY_CATALOG);

    loanLibraryInventoryItems = Array.isArray(loanLibraryInventoryItems) ? loanLibraryInventoryItems : [];

    useEffect(() => {
        onInventoryEditingChanged?.(editingIndex > -1);
    }, [editingIndex, onInventoryEditingChanged]);
        
    const resetEditingIndex = () => setEditingIndex(-1);

    const handleEditInventoryItem = (index: number) => setEditingIndex(index);

    const handleDeleteInventoryItem = (index: number) => {
        const inventoryItemsAfterDeletion = loanLibraryInventoryItems.filter((_item: Record<string, unknown>, currentIndex: number) => currentIndex !== index);
        onInventoryChange(inventoryItemsAfterDeletion);
    }

    const handleSaveInventoryItem = (updatedInventoryItem: Record<string, unknown>, index: number) => {
        if (canManageCatalog) {
            const updatedItems = loanLibraryInventoryItems.map((inventoryItem: Record<string, unknown>, currentIndex: number) =>
                currentIndex === index ? updatedInventoryItem : inventoryItem
            );
            onInventoryChange(updatedItems);
        }
        resetEditingIndex();
    }

    const handleCancelEditingInventoryItem = () => resetEditingIndex();


    const handleClickAddInventoryItem = () => {
        const emptyLoanLibraryInventoryItem = emptyLoanLibraryInventoryItemModel;
        emptyLoanLibraryInventoryItem.loanLibraryCatalogItemId = loanLibraryCatalogItemId;
        emptyLoanLibraryInventoryItem.copyNumber = loanLibraryInventoryItems.length + 1;

        const updatedItems = [...loanLibraryInventoryItems, emptyLoanLibraryInventoryItem];
        const newIndex = updatedItems.length - 1;
        onInventoryChange(updatedItems);

        setEditingIndex(newIndex);
    };

    const titleText = productName ? `${productName} - Inventory Copies` : 'Inventory Copies';

    return (
        <div>
            <h3>
                {titleText} ({loanLibraryInventoryItems.length})
            </h3>
            <p>Manage the physical or digital copies of this catalog item.</p>

            {
                loanLibraryInventoryItems.length > 0 &&
                <GridTable className={"searchResults"}>
                    <thead>
                    <tr>
                        <th>Item ID</th>
                        <th>Copy #</th>
                        <th>Shelf Location</th>
                        <th>Serial Number</th>
                        <th>Asset Number</th>
                        <th>Status</th>
                        <th>Notes</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                    loanLibraryInventoryItems.map((loanLibraryInventoryItem: Record<string, unknown>, index: number) => {

                            const loanLibraryInventoryItemId = getLoanLibraryInventoryItemId(loanLibraryInventoryItem, index);

                            return editingIndex === index ?
                                <LoanLibraryInventoryEditRow
                                    key={loanLibraryInventoryItemId}
                                    index={index}
                                    canManageCatalog={canManageCatalog}
                                    loanLibraryInventoryItem={loanLibraryInventoryItem}
                                    handleSaveInventoryItem={handleSaveInventoryItem}
                                    handleCancelInventoryItem={handleCancelEditingInventoryItem}/>
                                :
                                <LoanLibraryInventoryRow
                                    key={loanLibraryInventoryItemId}
                                    index={index}
                                    loanLibraryInventoryItem={loanLibraryInventoryItem}
                                    handleEditInventoryItem={handleEditInventoryItem}
                                    handleDeleteInventoryItem={handleDeleteInventoryItem}
                                />;
                        })
                    }
                    </tbody>
                </GridTable>
            }

            <GridCell className="text-center">
                <Button
                    name="btnAddCopy"
                    label="Add Copy"
                    onClick={handleClickAddInventoryItem}
                    isPrimary
                />
            </GridCell>
            {
                loanLibraryInventoryItems.length === 0 &&
                <p className="text-center">No copies added yet. Click &quot;Add Copy&quot; to add the first copy.</p>
            }
        </div>
    );
};

